// Notification sound + user preference (localStorage-backed).
// Uses Web Audio API so no external asset is required.

const PREF_KEY = "notify_sound_enabled";

export const isSoundEnabled = () => {
  try {
    return localStorage.getItem(PREF_KEY) !== "off";
  } catch {
    return true;
  }
};

export const setSoundEnabled = (on) => {
  try {
    localStorage.setItem(PREF_KEY, on ? "on" : "off");
  } catch {
    /* ignore */
  }
};

// A short two-note chime (A5 -> E6).
export const playChime = () => {
  if (!isSoundEnabled()) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const notes = [
      { f: 880, t: 0 },
      { f: 1320, t: 0.14 },
    ];
    notes.forEach(({ f, t }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = f;
      const start = ctx.currentTime + t;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.18, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.35);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.4);
    });
    setTimeout(() => {
      try {
        ctx.close();
      } catch {
        /* noop */
      }
    }, 1000);
  } catch {
    /* noop */
  }
};
